// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"610":"8ec2093a","801":"6cd27593","826":"4c8a367c","993":"6ad9c920"}[chunkId] + ".css";
};